import Vue from 'vue'
import store from '@/store'
import Component from './index.vue'

const SignAuthConstructor = Vue.extend(Component)
let instance = null

function getInstance () {
  if (!instance) {
    // 显式注入 store：Vue.extend 实例不继承根实例的 $store
    instance = new SignAuthConstructor({
      store,
      el: document.createElement('div')
    })
    document.body.appendChild(instance.$el)
  }
  return instance
}

/**
 * 签章授权校验（通用拦截）
 *
 * 调用：await this.$signAuth({ mobile, bankCardNo?, userName?, idCard? })
 *  - 已授权(needAuth=N) 或 验证成功 → resolve({ mobile })
 *  - 用户关闭弹窗 / checkUserSignAuth 不可用 → reject(Error)
 *  - 验证码错误/发送失败 → 组件内行内提示，允许重试，不会 reject
 *
 * @param {Object} options
 * @param {string} options.mobile      回显手机号（必填）
 * @param {string} [options.userName]  绑卡等场景传入
 * @param {string} [options.idCard]
 * @param {string} [options.bankCardNo]
 * @returns {Promise<{ mobile: string }>}
 */
export default function signAuth (options = {}) {
  return getInstance().start(options)
}
